import { render, staticRenderFns } from "./ObjectItem.vue?vue&type=template&id=6265269e&"
import script from "./ObjectItem.vue?vue&type=script&lang=js&"
export * from "./ObjectItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports